<template>
	<div class="partner-topbar">
		<BackLink classPrefix="partner-topbar" />
		<div class="partner-topbar__logo"></div>
		<div :style="{display: 'flex'}">
			<router-link :to="{name: 'partner'}">
				<button role="button" class="button partner-topbar__profile-icon">
					Strefa partnera
				</button>
			</router-link>
			<button
				@click.prevent="logout"
				role="button"
				class="button partner-topbar__logout button--outlined"
			>
				Wyloguj
			</button>
		</div>
	</div>
</template>

<script>
import Cookies from 'js-cookie';
import BackLink from '../BackLink';

export default {
	name: 'PartnerTopbar',
	components: {BackLink},
	methods: {
		logout() {
			Cookies.remove('connect.sid');
			this.$store.commit('setUser', null);
			this.$router.push({name: 'model'});
		},
	},
};
</script>
